export default function PieIcon8020Small() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.00001" cy="7.99992" r="6.47413" fill="#FD8E3F" fillOpacity="0.25" />
      <path
        d="M8 1.52583C6.6328 1.52583 5.30069 1.95866 4.1946 2.76228C3.08851 3.56591 2.26522 4.69906 1.84273 5.99935C1.42024 7.29964 1.42024 8.7003 1.84273 10.0006C2.26522 11.3009 3.08851 12.434 4.1946 13.2377C5.30069 14.0413 6.6328 14.4741 8 14.4741C9.3672 14.4741 10.6993 14.0413 11.8054 13.2377C12.9115 12.434 13.7348 11.3009 14.1573 10.0006C14.5798 8.7003 14.5798 7.29964 14.1573 5.99935L8 7.99997L8 1.52583Z"
        fill="#FD8E3F"
      />
    </svg>
  );
}
